import { useContext } from 'react';
import { EditionsContext } from '../components/context/editions-context';
export const useEditions = () => useContext(EditionsContext);
